import { useTranslation } from "react-i18next";
import { MBGLineWhite } from "../components/commons/MIcon";
import MPageHeader from "../components/commons/MPageHeader";

const AvatarProg = ({ message, isWrongImg = false }) => {
  const { t } = useTranslation();

  return <>
    <div
      className="w-100 h-100 bg-primary-400 d-flex flex-column"
      style={{}}
    >
      <MPageHeader isWhite={true} />
      <div className="flex-fill d-flex flex-column justify-content-between position-relative">
        <div
          className="position-absolute d-flex align-items-center justify-content-center"
          style={{
            zIndex: 0,
            inset: 0,
          }}
        >
          <MBGLineWhite
            className="position-relative"
            style={{
              width: "120%",
              top: 120,
            }}
          />
        </div>
        <div className="pt-4 px-4 text-white fw-bolder fs-4">
          <div>
            {message ? message : t("Please wait for a moment.")}
          </div>
        </div>
        <div className="px-2" style={{ zIndex: 1 }}>
          <img
            src={!isWrongImg ? "/imgs/loading_avatar.gif" : "/imgs/wrong-access.png"}
            alt="loading"
            style={{
              width: "90%",
              maxWidth: 300,
              pointerEvents: "none",
              filter: "drop-shadow(0px 0px 100px var(--bs-primary-100))",
              WebkitFilter: "drop-shadow(0px 0px 100px var(--bs-primary-100))",
            }}
            className="mx-auto d-block"
          />
        </div>
        <div className="text-center pb-5 px-5 w-100">
          {/* TODO: FOOTER */}
        </div>
      </div>
    </div>
  </>
};

export default AvatarProg;